import React from 'react';
import ArrowUp from 'react-icons/ti/arrow-up-thick';

const positionTop = {
  top: 15,
  right: 15,
};

const positionBottom = {
  bottom: 15,
  right: 15,
};

const style = {
  position: 'fixed',
  width: 45,
  height: 45,
  backgroundColor: 'rgba(255,255,255,0.35)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  cursor: 'pointer',
};

export default class ToTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speed: 25,
      visible: false,
    };
    this.scrollTop = this.scrollTop.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.onscroll = this.onScroll;
  }

  onScroll() {
    return window.scrollY < this.props.hideAt ? this.setState({ visible: false, speed: 25 }) : this.setState({ visible: true });
  }

  scrollTop() {
    if (window.scrollY > 0) {
      window.scrollBy(0, -this.state.speed);
      setTimeout(this.scrollTop, 10);
      this.setState({ speed: this.state.speed + 1 });
    }
  }

  render() {
    if (!this.state.visible) return null;
    const position = this.props.position === 'top' ? positionTop : positionBottom;
    return (
      <div style={{ ...this.props.style, ...position }} >
        <ArrowUp size="30" color="rgba(255,255,255, 0.65)" onClick={this.scrollTop} />
      </div>
    );
  }
}

ToTop.propTypes = {
  hideAt: React.PropTypes.number,
  position: React.PropTypes.string,
  style: React.PropTypes.object,
};

ToTop.defaultProps = {
  style,
  hideAt: 100,
  position: 'top',
};



// WEBPACK FOOTER //
// ./src/component.jsx